import { useEffect, useState } from 'react';

/** 프로필 이미지가 없거나 불러오지 못하면 보여 줄 기본 이미지 (public/) */
export const DEFAULT_AVATAR = '/default-avatar.svg';

interface AvatarProps {
  src?: string | null;
  size?: number;
  alt?: string;
}

/**
 * 원형 프로필 이미지.
 * 소셜 프로필 URL 은 만료되거나 차단될 수 있어 실패하면 기본 이미지로 바꾼다.
 * Google 이미지는 Referer 가 붙으면 403 을 주는 경우가 있어 no-referrer 로 요청한다.
 */
export default function Avatar({ src, size = 28, alt = '' }: AvatarProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  return (
    <img
      className="avatar"
      src={src && !failed ? src : DEFAULT_AVATAR}
      alt={alt}
      width={size}
      height={size}
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
}
